export const CLIENT_KIND = "client";

/**
 * Client Master Account — original approved product surface.
 * Uploader + History are Music Provider–only (omitted here).
 */
export const clientExperience = {
  kind: CLIENT_KIND,
  label: "Client",
  landingPath: "/brand-manager",
  routeRules: [
    { prefix: "/brand-manager", capability: "client.brands" },
    { prefix: "/llt", capability: "client.locations" },
    { prefix: "/dashboard", capability: "client.dashboard" },
    { prefix: "/reports", capability: "client.reports" },
    { prefix: "/master-account/channels", capability: "tenant.bootstrap" },
    { prefix: "/master-account/talent-request", capability: "tenant.bootstrap" },
    {
      prefix: "/master-account/in-production",
      capability: "tenant.bootstrap",
    },
    {
      prefix: "/master-account/messaging-schedule",
      capability: "tenant.bootstrap",
    },
    { prefix: "/master-account/account", capability: "tenant.settings.basic" },
    {
      prefix: "/master-account/user-management",
      capability: "tenant.users.manage",
    },
    // Canonical Client Account / User Management (Brand Manager plane)
    {
      prefix: "/brand-manager/account",
      capability: "tenant.settings.basic",
    },
    {
      prefix: "/brand-manager/user-management",
      capability: "tenant.users.manage",
    },
    { prefix: "/brand-manager/users", capability: "tenant.users.manage" },
    { prefix: "/master-account/locations", capability: "client.locations" },
    { prefix: "/master-account/billing", capability: "client.billing" },
    { prefix: "/master-account/support", capability: "tenant.bootstrap" },
    { prefix: "/brand-manager/support", capability: "tenant.bootstrap" },
    { prefix: "/master-account/faq", capability: "tenant.bootstrap" },
  ],
};
